import React, { PropTypes } from 'react'
import map from 'lodash/map'
import SearchFilter from 'components/SearchFilter'
import { hasActiveFilters, labelFromValue } from 'utils/filter'

import styles from './Filters.scss'

const Filters = ({
  clearFilters,
  filterData,
  filter,
  rules,
}) => {
  const handler = (type) => {
    return (value) => {
      filter({ type, value })
    }
  }

  const makeLabel = (type, label) => {
    const selectedLabel = labelFromValue({ value: rules[type], type, filterData })
    return selectedLabel ? `${label}:  ${selectedLabel}` : label
  }

  const renderFilters = () => {
    return map(filterData, ({ label, options }, type) => {
      return (
        <SearchFilter
          className={styles.filter}
          handleSubmit={handler(type)}
          id={`group-${type}`}
          key={type}
          options={filterData[type].options}
          text={makeLabel(type, label)}
        />
      )
    })
  }

  return (
    <div className={styles.base}>
      <div className={styles.label}>
        Filter by:
      </div>
      { renderFilters() }
      {
        hasActiveFilters(rules)
          ? (
            <button className={styles.clear} onClick={clearFilters}>
              Clear all
            </button>
          )
          : null
      }
    </div>
  )
}

Filters.propTypes = {
  clearFilters: PropTypes.func,
  filter: PropTypes.func,
  filterData: PropTypes.objectOf(PropTypes.shape({
    label: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })),
  })),
  rules: PropTypes.objectOf(PropTypes.string),
}

export default Filters




// WEBPACK FOOTER //
// ./src/components/List/components/Filters/Filters.js